<template>
    <el-card v-loading="!is_ok" class="page_card" ref="card">
        <div slot="header" class="clearfix" v-if="mode == 'fix'">
            <el-page-header @back="goBack" content="资金明细"></el-page-header>
        </div>
        <el-form :inline="true" ref="selectForm" :model="selectForm" class="demo-form-inline">
            <el-form-item label="企业名称/简称" v-if="mode != 'fix'">
                <el-select
                    v-model="selectForm.comId"
                    :multiple="false"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请输入企业名称/简称"
                    @change="selectChange"
                    :loading="is_select">
                    <el-option
                        v-for="item in componys"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="" v-if="mode == 'fix' && company">
                <el-link :underline="false" type="primary" style="font-size: 20px;">{{company.name}}</el-link>
            </el-form-item>
            <el-form-item label="">
                <el-date-picker
                    v-model="selectForm.timeRange"
                    type="daterange"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="资金方向">
                <el-select v-model="selectForm.inOrOut" placeholder="请选择">
                    <el-option
                        v-for="item in inOrOuts"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="">
                <el-checkbox v-model="selectForm.showFreeze">显示冻结和解冻</el-checkbox>
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" plain @click="select()" :loading="is_post">查询</el-button>
                <el-button plain @click="resetSelect()" :loading="is_post">重置</el-button>
                <!-- <el-button type="success" plain :loading="is_post" @click="addItem()" v-can="['btn:add_money']" :disabled="!this.company">+ 资金管理</el-button> -->
            </el-form-item>
        </el-form>

        <el-table v-loading="is_loading" :data="data" v-if="showtable" stripe :max-height="tableMaxHeight">
            <el-table-column label="企业名称" v-if="mode != 'fix' || !company" align="center">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.comName}}</span>
                </template>
            </el-table-column>
            <el-table-column label="关联磅单号" align="center">
                <template slot-scope="scope">
                    <span class="primary_text" v-if="scope.row.weightSn.length">{{scope.row.weightSn}}</span>
                    <span v-else>----</span>
                </template>
            </el-table-column>
            <el-table-column label="记账时间" align="center">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.addTime}}</span>
                </template>
            </el-table-column>
            <el-table-column label="资金方向" align="center">
                <template slot-scope="scope">
                    <span class="success_text" v-if="scope.row.inOrOut == 0">增加</span>
                    <span class="danger_text" v-if="scope.row.inOrOut == 1">减少</span>
                    <span class="danger_text" v-if="scope.row.inOrOut == 11">冻结</span>
                </template>
            </el-table-column>
            <el-table-column label="资金用途" align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.other.length">
                        <span class="danger_text" v-if="scope.row.inOrOut == 1">{{scope.row.other}}</span>
                        <span class="success_text" v-if="scope.row.inOrOut == 0">{{scope.row.other}}</span>
                    </div>
                    <div v-else>
                        <span class="danger_text" v-if="scope.row.inOrOut == 1">{{searchType(scope.row.type)}}</span>
                        <span class="success_text" v-if="scope.row.inOrOut == 0">{{searchType(scope.row.type)}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="金额(元)" align="center">
                <template slot-scope="scope" >
                    <span class="info_text" v-if="scope.row.inOrOut == 10">{{parseNums(scope.row.money)}}</span>
                    <span class="danger_text" v-if="scope.row.inOrOut == 11">{{parseNums(scope.row.money)}}</span>
                    <span class="danger_text" v-if="scope.row.inOrOut == 1">{{parseNums(scope.row.money)}}</span>
                    <span class="success_text" v-if="scope.row.inOrOut == 0">{{parseNums(scope.row.money)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="上期余额(元)" align="right">
                <template slot-scope="scope">
                    <span class="warning_text">{{parseNums(scope.row.beforeMoney)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="本期余额(元)" align="right">
                <template slot-scope="scope">
                    <span class="primary_text">{{parseNums(scope.row.afterMoney)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="当前冻结(元)" align="right">
                <template slot-scope="scope">
                    <span class="primary_text">{{parseNums(scope.row.freezeBalance)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="总余额(元)" align="right">
                <template slot-scope="scope">
                    <span class="primary_text">{{parseNums(scope.row.balance)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="备注" align="center">
                <template slot-scope="scope">
                    <span class="warning_text" v-if="scope.row.remark.length == 0">无</span>
                    <el-popover
                        v-else-if="scope.row.remark.length > 0"
                        placement="top-start"
                        title=""
                        width="250"
                        trigger="hover"
                        :content="scope.row.remark">
                        <el-button size="mini" slot="reference">备注</el-button>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column label="操作人">
                <template slot-scope="scope">
                    {{scope.row.uname}}
                </template>
            </el-table-column>

        </el-table>
        <footer style="height: 50px;position: absolute;bottom: 10px;width: calc(100% - 40px);">
            <el-pagination
                style="float: left;position: relative;top: 10px;"
                @current-change="pageChange"
                @size-change="handleSizeChange"
                :current-page.sync="selectForm.pageNum"
                :page-size="selectForm.pageSize"
                :page-sizes="selectForm.pageSizes"
                :hide-on-single-page="false"
                layout="sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </footer>

        <el-dialog
            title="资金管理"
            :visible.sync="add_dialog"
            width="30%"
            >
            <el-form ref="addForm" v-if="company" :model="addForm" :rules="rules" label-position="right" label-width="120px">
                <el-form-item label="公司名称" v-if="company">
                    <span class="primary_text">{{company.name}}</span>
                </el-form-item>
                <el-form-item label="开户行" v-if="company">
                    <span class="primary_text">{{company.bankAddress}}</span>
                </el-form-item>
                <el-form-item label="银行账号" v-if="company">
                    <span class="primary_text">{{company.bankNumber}}</span>
                </el-form-item>
                <el-form-item label="资金方向">
                    <el-radio-group v-model="addForm.inOrOut" @change="intouchange">
                        <el-radio-button label="0">打款</el-radio-button>
                        <el-radio-button label="1">扣款</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="资金用途">
                    <el-radio-group v-model="addForm.type" >
                        <el-radio-button label="0">货款</el-radio-button>
                        <el-radio-button label="1">冲账</el-radio-button>
                        <el-radio-button label="2">退款</el-radio-button>
                        <el-radio-button label="99">其他</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="其他资金用途" v-if="addForm.type == '99'" prop="other">
                    <el-input v-model="addForm.other" placeholder="请填写其他资金用途"  maxlength="20" show-word-limit :rules="[{ required: true, message: '请输入其他资金用途', trigger: 'blur' }]"></el-input>
                </el-form-item>

                <el-form-item label="上期余额(元)" v-if="company" align="right">
                    <span class="warning_text">{{company.balance}}</span>
                </el-form-item>
                <el-form-item label="金额(元)" prop="money" align="right">
                    <el-input v-model="addForm.money" type="number" placeholder="请输入操作金额,最多保留2位小数"></el-input>
                </el-form-item>
                <el-form-item label="本期余额(元)" align="right">
                    <span class="danger_text">{{endMoney}}</span>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input
                        type="textarea"
                        placeholder="请输入内容"
                        v-model="addForm.remark"
                        maxlength="100"
                        show-word-limit
                    >
                    </el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" @click="addSubmit()" plain :loading="is_post">提 交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </el-card>
</template>

<script>
import {parseTime} from '@/utils'
import request from '@/utils/request'
import {stringTrim} from '@/utils/elvalid'
import can from "@/directive/can/index.js"
import {mapGetters} from 'vuex'

export default {
    name: 'financial_list',
    directives:{can},
    computed:{
        endMoney(){
            if(!this.company || typeof this.company.balance == "undefined"){
                return "";
            }
            if(this.addForm.inOrOut == 0){
                //增加
                if(this.addForm.money && this.addForm.money.length > 0 && typeof parseFloat(this.addForm.money) == "number"){
                    return parseFloat(this.company.balance) + parseFloat(this.addForm.money);
                }else{
                    return this.company.balance;
                }
            }else if(this.addForm.inOrOut == 1){
                //减少
                if(this.addForm.money && this.addForm.money.length > 0 && typeof parseFloat(this.addForm.money) == "number"){
                    return parseFloat(this.company.balance) - parseFloat(this.addForm.money);
                }else{
                    return this.company.balance;
                }
            }
        },
        ...mapGetters([
            'permissions'
        ])
    },
    data(){
        let validateMoney =  (rule, value, callback)=>{
            if(this.addForm.inOrOut == 0){
                //增加
                if(parseFloat(value) > 100000000){
                    callback(new Error("打款金额不能超过1亿!"));
                }else{
                    callback();
                }
            }else{
                if(parseFloat(value) > parseFloat(this.company.balance)){
                    callback(new Error("扣款金额不能超过该账户余额!"));
                }else{
                    callback();
                }
            }
        }
        return {
            mode:"fix",
            is_ok:true,
            is_post:false,
            is_loading:false,
            is_select:false,
            //公司信息
            company:null,
            data:[],
            total:0,
            componys:[],
            selectForm:{
                comId:"",
                timeRange:[],
                inOrOut:"all",
                showFreeze:false,
                pageNum: 1,
                pageSize: 10,
                pageSizes:[10, 20, 50, 100]
            },
            inOrOuts:[
                {id:"all",label:"全部"},
                {id:0,label:"增加"},
                {id:1,label:"减少"}
            ],
            types:[
                {id:0,label:"货款"},
                {id:1,label:"冲账"}
            ],
            typesAll:[
                {id:-1,label:"冻结"},
                {id:0,label:"货款"},
                {id:1,label:"冲账"},
                {id:2,label:"退款"},
                {id:10,label:"优惠减免"},
                {id:11,label:"撤销优惠减免"},
                {id:90,label:"冻结"},
                {id:91,label:"解冻"}
            ],
            showtable:false,
            tableMaxHeight:0,
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            add_dialog:false,
            addForm:{
                comId:"",
                inOrOut:0,
                type:0,
                money:"",
                remark:"",
                other:""
            },
            rules:{
                money:[
                    { required: true, message: '请输入金额', trigger: 'blur' },
                    { pattern:/^([1-9]\d*(\.\d{1,2})?|[0]{1}\.\d{1,2})$/, message: '请输入一个正整数,最多保留2位小数', trigger: 'blur' },
                    { validator: validateMoney, trigger: 'blur' },
                ],
                other:[
                    { required: true, message: '请填写其他资金用途', trigger: 'blur' },
                    { validator: stringTrim, trigger: 'blur' }
                ]
            },
        }
    },
    methods:{
        addItem(){
            this.add_dialog = true;
        },
        goBack(){
            this.$router.go(-1);
        },
        parseTime(time){
            return parseTime(time,"{y}-{m}-{d} {h}:{i}:{s}");
        },
        intouchange(inout){
            if(this.addForm.type != 99){
                if(inout == 1){
                    this.addForm.type = 1;
                }else if(inout == 0){
                    this.addForm.type = 0;
                }
            }
        },
        resetSelect(){
            this.$refs["selectForm"].resetFields();
            this.selectForm = {
                comId:"",
                timeRange:[],
                inOrOut:"all",
                showFreeze:false,
                pageNum: 1,
                pageSize: 10
            };
            this.company = null;
            this.getData();
        },
        has_permission(permission){
            return this.permissions.includes(permission);
        },
         getCompany(){
            request.get("company/option").then(res=>{
                this.componys = res.data;
            }).catch(err=>{
            });
        },
        async selectChange(id){
            this.addForm.comId = id;
            this.getData(true);
            this.company = await this.getCompanyInfo(id);
        },
        select(){
            this.selectForm.pageNum = 1;
            this.getData();
        },
        pageChange(page){
            this.selectForm.pageNum = page;
            this.getData();
        },
        handleSizeChange(val){
            this.selectForm.pageSize = val;
            this.getData();
        },
        getData(is_init = false){
            if(!is_init){
                this.is_loading = true;
                this.is_post = true;
            }
            let tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.selectForm.$el.offsetHeight-85;
            if(this.mode == 'fix'){
                tableMaxHeight -= 60;
            }
            request.post("finance/list",this.selectForm).then(res=>{
                this.data = res.data.list;
                this.total = res.data.total;
                if(!is_init){
                    this.is_loading = false;
                    this.is_post = false;
                }else{
                    this.is_ok = true;
                    this.tableMaxHeight = tableMaxHeight;
                    this.showtable = true;
                }
            }).catch(err=>{
                if(!is_init){
                    this.is_loading = false;
                    this.is_post = false;
                }else{
                    this.is_ok = true;
                    this.tableMaxHeight = tableMaxHeight;
                    this.showtable = true;
                }
            });
        },
        parseNums(n,is_int=false) {
            //转化成字符串
            let str = n.toString();
            //若是整数自动补全小数位
            if (-1 == str.indexOf(".")) {
                str = str + ".00"
            }
            if(str.indexOf(".")!=-1){
                let x = str.indexOf('.') + 1;   //小数点的位置
                let y = str.length - x;  //小数的位数
                if(y > 0 && y == 1){
                    str = str + "0"
                }
            }
            //全部替换
            if (-1 != str.indexOf(",")) {
                str = str.replace(new RegExp(',', "g"), "")
            }
            let intSum = str.substring(0, str.indexOf(".")).replace(/\B(?=(?:\d{3})+$)/g, ',');//取到整数部分
            if(is_int){
                return intSum;
            }
            let dot = str.substring(str.length, str.indexOf("."))//取到小数部分搜索
            let ret = intSum + dot;
            return ret;
        },
        selectComMethod(name){
            if(name.length > 1){
                this.is_select = true;
                request.get("company/option?keyword="+name).then(res=>{
                    if(res.data && res.data.length > 0){
                        this.componys = res.data;
                    }else{
                        this.componys = [];
                    }
                    this.is_select = false;
                }).catch(err=>{
                    this.is_select = false;
                    console.log(err);
                });
            }
        },
        searchType(id){
            let res = "";
            for(let item of this.typesAll){
                if(id ==  item.id){
                    return item.label;
                }
            }
            return res;
        },
        addSubmit(){
            this.$refs["addForm"].validate((valid)=>{
                if(!valid) return false;
                if((this.addForm.type == 0 && this.addForm.inOrOut == 1) || (this.addForm.type == 1 && this.addForm.inOrOut == 0)){
                    this.$message.warning("资金冲账类型必须选择扣款方向");
                    return false;
                }
                if(this.addForm.type == 0 && this.addForm.inOrOut == 1){
                    this.$message.warning("货款冲账类型必须选择打款方向");
                    return false;
                }
                this.is_post = true;
                request.post("finance/add_balance_record",this.addForm).then(res=>{
                    this.addForm.inOrOut = 0;
                    this.addForm.type = 0;
                    this.addForm.money = "";
                    this.addForm.remark = "";
                    this.addForm.other = "";
                    this.add_dialog = false;
                    this.data.unshift(res.data);
                    this.$message.success("新增财务明细成功!");
                    this.is_post = false;
                }).catch(err=>{
                    this.is_post = false;
                });
            });
        },
        getCompanyInfo(id){
            return new Promise((resolve, reject)=>{
                request.get("company/detail?id="+id).then(res=>{
                    resolve(res.data);
                }).catch(err=>{
                    reject(err);
                });
            });
        },

    },
    created(){

    },
    async mounted() {
        if(typeof this.$route.query.id != 'undefined'){
            this.mode = "fix";
            try{
                this.company = await this.getCompanyInfo(this.$route.query.id);
                this.selectForm.comId = this.company.id;
                this.addForm.comId = this.company.id;
                this.getData(true);
            }catch(e){
                console.log(e);
            }finally {
                // todo ...
            }
        }else{
            this.mode = "nofix";
            this.getData(true);
        }
        this.getCompany();
    }
}
</script>

<style scoped lang="scss">

</style>
